import sectionReviewGrid02Css from '../css-snippets/section-review-grid-02';

const html = `
<style>${sectionReviewGrid02Css}</style>
<div
  class="review-grid-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="review-grid-container"
  data-card-background-color="#FFFFFF"
  style="background-color: #fff7f5"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <div class="wrap-review-grid">
      <div data-attribute="title-review" class="title-review">
        <h2 style="text-align: center">Customer Testimonials&nbsp;</h2>
        <h2 style="text-align: center">
          What Our Customers Say About Us&nbsp;
        </h2>
      </div>
      <div data-attribute="body-review" class="body-review swiper">
        <div class="review-slider swiper-wrapper">
          <!-- review items -->
        </div>
      </div>
      <div class="wrap-arrows">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="arrow-left"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="arrow-right"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </div>
    </div>
  </div>
</div>

`;
export default html;
